import {forwardRef} from 'react'
import {type TextProps} from 'react-native'
import Svg, {
  Defs,
  LinearGradient,
  Path,
  type PathProps,
  Polygon,
  Rect,
  Stop,
  type SvgProps,
} from 'react-native-svg'
import {Image} from 'expo-image'

import {useLogoVariant} from '#/view/icons/useLogoVariant'
import {flatten, useTheme} from '#/alf'
import {useSemanticTokens} from '#/wsocial/service/design-system'

const ratio = 57 / 64

type Props = {
  allowVariants?: boolean
  fill?: PathProps['fill']
  style?: TextProps['style']
} & Omit<SvgProps, 'style'>

export const Logo = forwardRef(function LogoImpl(props: Props, ref) {
  const t = useTheme()
  const ss = useSemanticTokens()
  const {allowVariants = true, fill, ...rest} = props
  const gradient = fill === 'sky'
  const styles = flatten(props.style)
  const _fill = gradient
    ? 'url(#sky)'
    : fill || styles?.color || ss.button.primary.bg
  // @ts-ignore it's fiiiiine
  const size = parseInt(rest.width || 32, 10)

  const logoVariant = useLogoVariant(allowVariants)

  if (logoVariant !== 'default') {
    const isJapanLogo = logoVariant === 'japan'
    return (
      <Image
        source={
          isJapanLogo
            ? require('../../../assets/icons/custom_logo_japan.svg')
            : size > 100
              ? require('../../../assets/kawaii.png')
              : require('../../../assets/kawaii_smol.png')
        }
        accessibilityLabel="W Social"
        accessibilityHint=""
        accessibilityIgnoresInvertColors
        style={[{height: size, aspectRatio: isJapanLogo ? 2 : 1.4}]}
      />
    )
  }

  return (
    <Svg
      width="73"
      height="73"
      viewBox="0 0 73 73"
      fill="none"
      // @ts-ignore it's fiiiiine
      ref={ref}
      {...rest}
      style={[{width: size, height: size * ratio}, styles]}>
      <Rect width="73" height="73" rx="15" ry="15" fill="#28004e" />

      <Polygon
        points="21.58 17.23 9.28 17.23 27.58 60.13 34.2 48.88 21.58 17.23"
        fill="#fff"
      />

      <Polygon
        points="36.76 37.88 46.47 36.99 54.01 11.55 66.73 11.55 46.47 60.25 36.76 37.88"
        fill="#61a38b"
      />

      <Path
        d="M39.12,37.67l6.19-.57c.7-.06,1.29-.55,1.49-1.22l7.35-24.27c.22-.73.88-1.23,1.64-1.23h8.87c1.22,0,2.05,1.24,1.58,2.37l-19.33,46.43c-.48,1.17-1.35,1.06-2.65,1.06l-6.56-20.19c-.47-1.07.25-2.28,1.42-2.39Z"
        fill="#61a38b"
      />

      <Path
        d="M30.58,28.15l3.78-5.98c1.46-2.31,4.96-1.85,5.77.77l4.14,13.49,5.58-19.2h11.88l-17.46,43.02-13.68-32.1Z"
        fill="#fff"
      />

      <Path
        d="M34.55,37.34l2.99-4.73c1.47-2.32,4.99-1.85,5.79.77l.93,3.04,7.54-26.05h12.72l-20.26,49.87-9.71-22.91Z"
        fill="#1df2ba"
      />
    </Svg>
  )
  /*
  return (
    <Svg
      fill="none"
      // @ts-ignore it's fiiiiine
      ref={ref}
      viewBox="0 0 64 57"
      {...rest}
      style={[{width: size, height: size * ratio}, styles]}>
      {gradient && (
        <Defs>
          <LinearGradient id="sky" x1="0" y1="0" x2="0" y2="1">
            <Stop offset="0" stopColor="#0A7AFF" stopOpacity="1" />
            <Stop offset="1" stopColor="#59B9FF" stopOpacity="1" />
          </LinearGradient>
        </Defs>
      )}

      <Path
        fill={_fill}
        d="M13.873 3.805C21.21 9.332 29.103 20.537 32 26.55v15.882c0-.338-.13.044-.41.867-1.512 4.456-7.418 21.847-20.923 7.944-7.111-7.32-3.819-14.64 9.125-16.85-7.405 1.264-15.73-.825-18.014-9.015C1.12 23.022 0 8.51 0 6.55 0-3.268 8.579-.182 13.873 3.805ZM50.127 3.805C42.79 9.332 34.897 20.537 32 26.55v15.882c0-.338.13.044.41.867 1.512 4.456 7.418 21.847 20.923 7.944 7.111-7.32 3.819-14.64-9.125-16.85 7.405 1.264 15.73-.825 18.014-9.015C62.88 23.022 64 8.51 64 6.55c0-9.818-8.578-6.732-13.873-2.745Z"
      />
    </Svg>
  )*/
})
